import countries from '../../core/countries.fr.json';
import provinces from '../../core/provinces.fr.json';

export default {
  countries,
  provinces,
};
